module.exports = __webpack_public_path__ + "static/img/1_0016.364293a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0016.jpg
// module id = hjSt
// module chunks = 0